// extracted by mini-css-extract-plugin
export default {"container":"container-HDcqqvGa","currentUser":"currentUser-ILVX1Zct","cardContainer":"cardContainer-zEMLVSKt","cardImage":"cardImage-Qzk9551O","countBadge":"countBadge-C6Wjr4RQ"};